import { setGlobal } from 'reactn';
import setAuthToken from "./actions/setAuthToken";
import initIO from "./actions/initIO";
import store from "./store";
import jwtDecode from 'jwt-decode';
import axios from "axios";
import Config from "./config";
import { Cookies } from "react-cookie";
const init = async () => {

    document.addEventListener('gesturestart', e => {
        e.preventDefault();
    });

    if (localStorage.getItem('app') !== 'Clover 2.x.x') {
        localStorage.clear();
        localStorage.setItem('app', 'Clover 2.x.x');
    }
    const cookies = new Cookies();
    // let epointsToken = cookies.nts);
    let eToken = cookies.get('EPOINTS_SSO');
    let brand = null;
    // eToken = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwczovL3N0YWZmLWFwaS5kZXYubWF0dGhld3NsaXF1b3IuY29tLmF1L3VzZXIvcmVmcmVzaC10b2tlbiIsImlhdCI6MTc1OTgwMjYwMSwiZXhwIjoxNzU5ODI5OTk0LCJuYmYiOjE3NTk4MDgzOTQsImp0aSI6ImxIRk9MbWtoQkt1Rk9YbVIiLCJzdWIiOjIwNywicHJ2IjoiYTBmM2U3NGJlZGY1MTJjNDc3ODI5N2RlNWY5MjA4NmRhZDM5Y2E5ZiIsInNpZCI6ImFkbWluQG1hdHRoZXdzbGlxdW9yLmNvbSIsInBob25lIjoiYWRtaW5AbWF0dGhld3NsaXF1b3IuY29tIiwiYnJhbmRfY29kZSI6Im1hdHRoZXdzbGlxdW9yIiwiaW1laSI6InBvcnRhbDEyMyJ9.EB2oqEtobkhKIGTcsv09JLn6I3kYwRTQscGZjKJU7lo';
    let token = localStorage.getItem('token');

    if(token && eToken){
        const eDecoded = jwtDecode(eToken, {complete: true});
        const decoded = jwtDecode(token, {complete: true});
        if(eDecoded.sid != decoded.sid){
            localStorage.removeItem("token");
            localStorage.removeItem("user");
            token = null;
        }
    }

    if(!token || token.length == 0 || typeof token === 'undefined'){
        token = eToken;
    }
    let userString = localStorage.getItem('user');
    let user = userString ? JSON.parse(userString) : null;

    if (token) {

        const decoded = jwtDecode(token, {complete: true});
        const eDecoded = jwtDecode(eToken, {complete: true});
        brand = eDecoded?.brand_code ?? eDecoded?.brand;
        cookies.set('BRAND', brand);

        const dateNow = new Date();
        let isExpired = (decoded.exp * 1000 < dateNow.getTime());
        let result;

        if (!isExpired) {
            console.log(isExpired)
            try {
                const res = await axios({
                    method: "post",
                    url: (Config.url || '') + "/api/check-user-token",
                    data: {token: token},
                    headers: {
                        'brand-code': brand ?? null
                    }
                });
                result = res.data;
            } catch (e) {
                console.log(e)
                result = null;
            }
        }

        if (!result || result.error) {
            localStorage.removeItem("token");
            localStorage.removeItem("user");
            token = localStorage.getItem('token');
            userString = localStorage.getItem('user');
            user = userString ? JSON.parse(userString) : null;
        } else {
            localStorage.setItem('token', result.token);
            localStorage.setItem('user', JSON.stringify(jwtDecode(result.token)));
            token = localStorage.getItem('token');
            userString = localStorage.getItem('user');
            user = userString ? JSON.parse(userString) : null;
        }
    }




    if (token) {
        setAuthToken(token);
        store.dispatch(initIO(token));
    }



    const state = {
        version: '2.5.2',
        entryPath: window.location.pathname,
        token,
        brand: brand ?? null,
        user: user || (token ? jwtDecode(token) : {}),
        rooms: [],
        searchResults: [],
        searchResultsATG: [],
        favorites: [],
        meetings: [],
        notification: [],
        nav: 'rooms',
        search: '',
        isExpand: false,
        over: null,
        isPicker: false,
        messages: [],
        streams: [],
        inCall: false,
        video: true,
        audio: true,
        audioStream: null,
        videoStream: null,
        screenStream: null,
        callStatus: null,
        counterpart: null,
        callDirection: null,
        meeting: null,
        showPanel: true,
        panel: 'standard',
        newGroupUsers: [],
        newGroupUsersATG: [],
        openInfo: false,
        showReply: false,
        showModalUpdateTitle: false,
        showModalAddToGroup : false,
        showModalForward : false,
        roomActive : false,
        reply: false,
        messageReply: false,
        currentMessage: '',
        messageGetData: [],
        messageModeAction: 'new',
        messageForward: [],
    };

    setGlobal(state).then(() => console.log('Global state init complete!', state));


}

export default init;
